import React, { useState, useEffect } from "react";

const backgroundImages = [
  "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767087293_6c52a6f2817f88e00d01.webp",
  "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767087328_72369edfc22db5687c61.webp",
  "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767087359_190ecbbf4aec5a7c2f30.webp",
];

function HeroWithSlideshow() {
  const [bgIndex, setBgIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  // Slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Screen Resize Detect
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="position-relative m-0">

      {/* Background Section */}
      <div
        className="d-flex align-items-center"
        style={{
          backgroundImage: `url(${backgroundImages[bgIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          width: "100%",
          transition: "background-image 1s ease-in-out",
        }}
      >
        <div className="container">
          <div className="row justify-content-center text-center text-white">
            <div className="col-lg-10 col-md-11 col-sm-12 px-3">

              <h1 className="fw-bold text-white display-5 display-md-3 display-lg-2 mb-4">
                A Diversified Business Group Operating Across Multiple Industries
              </h1>

              <p
                className="fw-semibold fs-6 fs-md-5 mx-auto mb-4 mt-4"
                style={{ maxWidth: "800px" }}
              >
                Visko Group brings together multiple businesses across different sectors,
                focused on innovation, scalability, and sustainable growth.
              </p>

            </div>
          </div>
        </div>
      </div>

      {/* Banner Section */}

    </div>
  );
}

export default HeroWithSlideshow;